<template>
  <div class="profile-item" data-v-step="0">
    <div class="profile-btn" @click="showDropDown = !showDropDown">
      <font-awesome-icon
        class="icon-profile"
        :class="showDropDown ? 'active' : ''"
        icon="sort-down"
      />
    </div>
    <div class="profile-info">
      <p>{{getUserLoged.name}}</p>
      <span>{{getUserLoged.companyName}}</span>
    </div>
    <div class="profile-image" style="cursor:pointer;" @click="showDropDown = !showDropDown">
      <img
        :src="getUserLoged.PhotoProfile"
        alt="user-profile"
      />
    </div>
    <div v-if="showDropDown" class="list-menu-acount">
      <ul>
        <li>
          <router-link @click="showDropDown = !showDropDown" to="/accountsettings"
            ><p>Account Settings</p>
            <font-awesome-icon icon="chevron-right"
          /></router-link>
        </li>
        <li>
          <a @click="LogOutBtn">
            <p>Log Out</p>
            <font-awesome-icon icon="chevron-right"/>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  data: () => ({
    showDropDown: false,
  }),
  computed:{
    ...mapGetters("UserManager",["getUserLoged"])
  },
  methods:{
    ...mapActions("UserManager",["LogOut"]),
    LogOutBtn(){
      this.LogOut();
      this.$router.push({path:"/login"})
    }
  }
};
</script>

<style>
.profile-item {
  position: relative;
  display: flex;
  align-items: center;
  margin: 0 15px;
}
.profile-item .list-menu-acount {
  position: absolute;
  top: 45px;
  left: 22%;
  width: auto;
  height: auto;
  background: white;
  color: black;
  transition: 0.5s;
}

.profile-item .list-menu-acount ul {
  list-style-type: none;
  padding: 0;
}
.profile-item .list-menu-acount ul li {
  padding: 5px 10px 5px 5px;
  border-bottom: 1px solid var(--third-color);
  border-top: 1px solid var(--third-color);
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.profile-item .list-menu-acount ul li a {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.profile-item .list-menu-acount ul li a p {
  margin-bottom: 0;
  margin-right: 5px;
}
.profile-item .profile-image {
  width: 40px;
  height: 40px;
}
.profile-item .profile-image img {
  width: 100%;
  border-radius: 100%;
}
.profile-item .profile-info {
  text-align: right;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 0 10px;
}
.profile-item .profile-info p {
  font-family: Pt Sans, sans-serif;
  font-weight: bold;
  font-size: 0.9rem;
  color: var(--second-color);
  margin: 0;
}

.profile-item .profile-info span {
  font-family: Pt Sans, sans-serif;
  font-weight: 400;
  font-size: 0.8rem;
  color: var(--second-color);
  opacity: 0.4;
}

.profile-item .profile-btn {
  display: flex;
  justify-content: center;
  align-self: center;
  color: var(--sixth-color);
  font-size: 17pt;
}
.icon-profile {
  transition: 0.5s;
}
.icon-profile.active {
  transform: rotate(180deg);
  transition: 0.5s;
}
</style>